import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=35bbe1e8&"
import script from "./reset-pwd.vue?vue&type=script&lang=js&"
export * from "./reset-pwd.vue?vue&type=script&lang=js&"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports